export { default } from './CustomerList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Customer/CustomerList/index.js